import * as Types from "./types";

const initialState = {
  dados: {},
  loadingFormulario: false,
};

export default function formularioReducer(state = initialState, action) {
  switch (action.type) {
    case Types.SET_FORMULARIO:
      return { ...state, dados: action.payload };
    case Types.LOADING_FORMULARIO:
      return { ...state, loadingFormulario: action.payload };
    default: {
      return state;
    }
  }
}
